import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { FadeVariant, fadeVariants } from '@pkg/motion';
import { designColor, styledLayout, styledReset } from '@pkg/primitives';

import { backdropTransition, drawerTransition, DrawerVariant, drawerVariants } from './Drawer.motion';

import { tokens } from './Drawer.tokens';

interface StyledDrawerProps {
    $fullscreen?: boolean;
}

const parentBaseStyles = css`
    ${styledReset.borderBox};
    // TODO: This z-index should come from a global source-of-truth.
    z-index: 200;
    position: fixed;
    inset: 0;
`;

export const StyledDrawer = styled(motion.div).attrs({
    variants: drawerVariants,
    initial: DrawerVariant.Hidden,
    animate: DrawerVariant.Show,
    exit: DrawerVariant.Hidden,
    transition: drawerTransition,
})<StyledDrawerProps>`
    ${parentBaseStyles};
    overflow: hidden;

    ${({ $fullscreen }) => {
        if ($fullscreen) {
            return css`
                background-color: ${designColor.raisinDark};
            `;
        } else {
            return css`
                --drawer-max-height: ${tokens.drawer.maxHeight}px;
                top: auto;
                background-color: ${designColor.raisin};
                border-top-left-radius: ${tokens.drawer.radius}px;
                border-top-right-radius: ${tokens.drawer.radius}px;
            `;
        }
    }};
`;

export const Interior = styled.div`
    --thumb-color: ${designColor.brandPurple};
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    max-height: var(--drawer-max-height);
    overflow-y: scroll;

    ${styledLayout.scrollbar({
        thumbColor: 'var(--thumb-color)',
        trackColor: 'transparent',
    })};
`;

export const Backdrop = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: backdropTransition,
})`
    ${parentBaseStyles};
    background-color: rgb(0, 0, 0, 0.3);
    backdrop-filter: blur(4px);
`;
